import { Card } from "@dune/ui";
import { useFormContext, useWatch } from "react-hook-form";
import { ConstructionSiteDetailsFormData } from "../../../../../component/brokers/constructionSites/useConstructionSiteDetailsForm";
import { ControlledPriceInput } from "../../../../../components/inputs/ControlledPriceInput";

interface TotalCostOperationProps {
	isDisabled?: boolean;
}

export const TotalCostOperation = ({
	isDisabled = false,
}: TotalCostOperationProps) => {
	const { control } = useFormContext<ConstructionSiteDetailsFormData>();

	const buildingTypeValue = useWatch({
		control,
		name: "actions.buildingType",
	});
	const shouldDisplayHT = ["COMMERCIAL_BUILDING", "OFFICE_BUILDING"].includes(
		buildingTypeValue || "",
	);

	return (
		<Card className="p-6 flex flex-row gap-4">
			<div className="text-gray-900 w-full">
				Pour un montant prévisionnel total de
			</div>
			{shouldDisplayHT ? (
				<div className="flex flex-row gap-2 w-full items-center">
					<ControlledPriceInput
						control={control}
						name="totalAmountHT"
						iconOrText="€ HT"
						disabled={isDisabled}
					/>
					{" et "}
					<ControlledPriceInput
						control={control}
						name="totalAmountTTC"
						iconOrText="€ TTC"
						disabled={isDisabled}
					/>
				</div>
			) : (
				<ControlledPriceInput
					control={control}
					name="totalAmountTTC"
					iconOrText="€ TTC"
					disabled={true}
				/>
			)}
		</Card>
	);
};
